<template>
    <div>
        <div class="top-menu">
            <div class="logo fl clearfix"><img :src="$route.meta.keepAlive === 3 ? ''+$parent.baseUrl+'/static/images/logo1.png' : ''+$parent.baseUrl+'/static/images/logo.png'" class="img db"/></div>
            <div class="in clearfix">
                <ul class="nav clearfix fl">
                    <li v-if="$parent.cooke == -1"><router-link :to="{path:''+$parent.baseUrl+'/'}" :class="$route.meta.keepAlive != 1 ? 'active-none' : ''">首页</router-link></li>
                    <!-- <li><router-link :class="$route.meta.pageType === 0 ? 'router-link-active' : ''" :to="{path:''+$parent.baseUrl+'/yuYingGather'}">舆情分析</router-link></li>
                    <li><router-link :class="$route.meta.pageType === 5 ? 'router-link-active' : ''" :to="{path:''+$baseUrl+'/competingReport'}">竞对报告</router-link></li>
                    <li><a href="http://hot.nybkz.com/" target="_blank">热点事件</a></li>
                    <li><router-link :to="{path:''+$parent.baseUrl+'/problem'}">帮助文档</router-link></li>
                    <li><router-link :class="$route.meta.pageType === 3 ? 'router-link-active' : ''" :to="{path:''+$parent.baseUrl+'/product'}">产品市场</router-link></li> -->
                    <li v-for="(item,index) in navigationMenuList" :key="index">
                        <router-link :class="$route.meta.pageType === item.pageType ? 'router-link-active' : ''" v-if="item.type===1" :to="{path:''+$parent.baseUrl+item.url}">{{item.name}}</router-link>
                        <a v-else-if="item.type===2" :href="item.url" target="_blank">{{item.name}}</a>
                    </li>
                    <!-- <li><router-link :to="{path:''+$parent.baseUrl+'/monitoring'}">定向监测</router-link></li> -->
                    <!-- <li class="saoma">
						<a href="javascript:void(0);">疫情分析</a>
						<div class="url-fu">
						    <img src="http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_briefdoc_new/tool/yiqingfenxi.png" class="img db">
						    <span class="name db ac">扫码看疫情全网传播分析</span>
						</div>
					</li> -->
                </ul>
                <div class="clearfix fr">
                    <div class="url saoma fl" v-if="memberBuyIconShow==1">
                        <router-link :to="$baseUrl+'/vipBuy'">
                            <i class="icons recharge-icon"></i>
                        </router-link>
                    </div>
                    <!-- <a class="url all-a fl" href="#"><i class="icons all-icon"></i>全站导航</a>  -->
                    <div class="url saoma fl">
                        <a href="javascript:void(0);">
                            <i class="icons sj-icon"></i>
                        </a>
                        <div class="url-fu">
                            <img :src="downloadImg" class="img db">
                            <span class="name db ac">扫码下载客户端</span>
                        </div>
                    </div>
                    <div class="url fl"  v-if="$parent.isSignin">
                        <a href="https://u1.nybkz.com/user/msglist?publish_type=2&msg_status=-1" target="_blank">
                            <i class="bull" v-if="$parent.newest"></i>
                            <i class="icons xx-icon"></i>
                        </a>
                        <!-- 最新消息 -->
                        <div class="news-mask" v-if="$parent.notceTips">
                            <p>系统消息</p>
                            <a class="ovhidden2 db mt10 color-blue" :href="$parent.newNotice.url" target="_blank" v-html="$parent.newNotice.title"></a>
                            <p class="mt10 clearfix">
                                <span class="fl">{{$parent.newNotice.createTime}}</span>
                                <span class="color-blue cp fr" @click="closeNewsmask();">关闭</span>
                            </p>
                        </div>
                    </div>
                    <div class="url saoma fl" v-if="showQuesstion===1">
                        <router-link :to="$baseUrl+'/questionnaire'">
                            <i class="iconfont icon-icon_wjdc" style="color:#8A8A99;font-size:18px"></i>
                        </router-link>
                    </div>
                    <div class="url fl" v-if="!$parent.isSignin">
                        <a class="url-a" :href="'https://u1.nybkz.com/member/login?url='+$parent.realmName+''+$parent.baseUrl+'/yuYingGather'">登录</a><a class="url-a" :href="'https://u1.nybkz.com/member/register?url='+$parent.realmName+''+$parent.baseUrl+'/yuYingGather'">注册</a>
                    </div>
                    <div class="url top-user cklearfix fl" v-if="$parent.isSignin">
                        <div class="text">
                            <img :src="$parent.headImg === '' ? ''+$parent.baseUrl+'/static/images/headImg.png' : $parent.headImg" class="img fl" :onerror="defaultImg"/>
                            <span class="name">{{$parent.nickname}}</span>
                        </div>
                        <ul class="user-nav ac">
                            <li v-for="(item,index) in userCenterMenuList" :key="index">
                                <router-link v-if="item.name!='账户中心'&&item.name!='退出登录'" :to="{path:''+$parent.baseUrl+item.path}">{{item.name}}</router-link>
                                <a v-else-if="item.name == '账户中心'" :href="item.path" target="view_window">{{item.name}}</a>
                                <a v-else href="javascript:void(0);" @click="logOut();">{{item.name}}</a>
                            </li>
                            <!-- <li><a href="https://u1.nybkz.com/user/index" target="view_window">账户中心</a></li>
                            <li><router-link :to="{path:''+$parent.baseUrl+'/vipRight'}">我的会员</router-link></li>
                            <li><router-link :to="{path:''+$parent.baseUrl+'/myCollect'}">我的收藏</router-link></li>
                            <li><router-link :to="{path:''+$parent.baseUrl+'/myDownload'}">我的下载</router-link></li>
                            <li><router-link :to="{path:''+$parent.baseUrl+'/receiveSet'}">我的联系人</router-link></li>
                            <li><router-link :to="{path:''+$parent.baseUrl+'/feedback'}">在线反馈</router-link></li>
                            <li><router-link :to="{path:''+$parent.baseUrl+'/systemSettings'}">系统设置</router-link></li>
                            <li><router-link :to="{path:''+$parent.baseUrl+'/addData'}">数据补录</router-link></li>
                            <li><a href="javascript:void(0);" @click="logOut();">退出登录</a></li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex';
export default {
    name: "left",
    computed:{
        ...mapState({
            showData: state => state.show.showData,
            showQuesstion: state => state.show.showQuesstion,
            userCenterMenuList: state => state.show.userCenterMenuList
        })
    },
    props: "",
    data() {
        return {
            sid:'',//竞对方案ID
			downloadImg:'',//移动端二维码
            reportTit:'',//竞对方案名称
            defaultImg:'this.src="'+this.$parent.baseUrl+'/static/images/headImg.png"', //默认图片
            showQuestion:2,
            navigationMenuList:[],
            memberBuyIconShow:''
        }
    },
    mounted() {
        this.$nextTick(() =>{
            setTimeout(()=>{
                let kf = document.querySelector('#icon_module')
                if(kf.style!=null){
                    kf.style.display = 'none';
                }
            },100)
            this.getEwm();
        })
    },
    created() {
    },
    methods: {
		// 获取APP下载二维码
		getEwm (){
			let that = this;
			that.$api.get('open/config',null,r =>{
                this.downloadImg = r.data.appDownloadQrcode;
                this.navigationMenuList = r.data.navigationMenuList;
                this.memberBuyIconShow = r.data.memberBuyIconShow
                this.$store.dispatch('show/getMenuList',r.data.leftMenuList);
                this.$store.dispatch('show/getplatformList',r.data.platformList);
                this.$store.dispatch('show/getuserCenterMenuList',r.data.userCenterMenuList);
                this.$store.dispatch('show/getmediaLevelList',r.data.mediaLevelList);
                this.$store.dispatch('show/getmediaLevelTips',r.data.mediaLevelTipsList);
                this.$store.dispatch('show/getmemberRechargeIcon',r.data.memberRechargeIcon);
                this.$store.dispatch('show/getcompanyTypes',r.data.companyTypes);
                that.$store.dispatch('show/getConfigInfo',r.data)
			})
		},
        logOut () {
            let that = this;
            that.$parent.loadModal(true,'正在退出登录...');
            that.$api.get('user/index/logout', null, r => {
                that.$parent.returnCode(r,function(){
                    window.location.href = 'https://u1.nybkz.com/member/login?url=https://'+window.location.host+'/vindex/yuYingGather'
                })
            })
        },
        // 关闭消息弹框
        closeNewsmask () {
            let that = this;
            that.$parent.notceTips = false;
            let datas = {
                msgId:that.$parent.newNotice.msgId
            }
            that.$api.post('user/index/update-notice', {data:datas}, r => {
                that.$parent.returnCode(r,function(){})
            })
        }
    }
}
</script>
<style lang="">

</style>



// WEBPACK FOOTER //
// src/components/topMenu.vue